import { Search, X } from "lucide-react";
import { Input } from "@/components/ui/Input";
import { Button } from "@/components/ui/Button";
import { cn } from "@/lib/utils";

/**
 * `ariaLabel` names what this box searches. A page with one search box is
 * named well enough by its placeholder; a page with two — a conversation
 * search beside a message search — is not, and a screen reader reads both as
 * "Search".
 */
const SearchInput = ({ value, onChange, placeholder = "Search...", className = "", inputClassName = "", ariaLabel }) => {
  return (
    <div className={cn(`relative flex-1 min-w-0`, className)}>
      {/* Icon */}
      <Search size={16} className="absolute left-4 top-1/2 -translate-y-1/2 text-text-secondary" />

      {/* Input */}
      <Input
        aria-label={ariaLabel}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        value={value}
        className={cn(
          "w-full bg-background-secondary text-text-primary placeholder:text-text-muted pl-10 pr-10 py-2 rounded-full outline-none focus:border-border-input transition",
          inputClassName,
        )}
      />

      {/* Clear Button */}
      {value && (
        <Button
          onClick={() => onChange("")}
          aria-label="Clear search"
          className="absolute right-3.5 top-1/2 -translate-y-1/2 flex items-center justify-center p-1 rounded-full text-text-muted hover:text-text-primary hover:bg-background-tertiary transition cursor-pointer"
        >
          <X size={13} aria-hidden="true" />
        </Button>
      )}
    </div>
  );
};

export default SearchInput;
